import React, { useState } from "react";
import PageHeading from "../../components/PageHeading";
import { useQuery } from "react-query";
import requestedBalanceServices from "../../services/requestedBalance";
import { Navigate, useNavigate } from "react-router-dom";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";
import Table from "../../components/Table";
import DButton from "../../components/DButton";
import { statusMessage } from "../../utils/functions";
import moment from "moment";

const columns = [
  { Header: "رقم المعرف (ID)", accessor: "id" },
  { Header: "اسم المستخدم", accessor: "username" },
  { Header: "الرصيد الحالي", accessor: "balance_user_current" },
  { Header: "الرصيد المطلوب", accessor: "balance_requested" },
  { Header: "الرصيد عند الطلب", accessor: "balance_current" },
  { Header: "الرصيد قبل التحويل", accessor: "balance_before_transfer" },
  { Header: "الرصيد بعد التحويل", accessor: "balance_after_transfer" },
  { Header: "التاريخ", accessor: "created_at" },
  { Header: "حالة الطلب", accessor: "status" },
  { Header: "التحكم", accessor: "actions" },
];
const Index = ({ title }) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const { data, isLoading, error } = useQuery(
    ["getRequestedBalances", currentPage],
    () => requestedBalanceServices.getRequestedBalances(currentPage + 1),
    { staleTime: 10000, cacheTime: 10000 }
  );
  const editRequestedBalance = (id) => {
    navigate("/balance-requested/" + id);
  };

  const formattedData = (data) => {
    if (data.length > 0) {
      return data.map((d) => ({
        ...d,
        username: d.user.name,
        balance_user_current: d.user.balance + "$",
        balance_requested: d.balance_requested + "$",
        balance_current: d.balance_current + "$",
        balance_before_transfer:
          d.balance_before_transfer === undefined
            ? "Nan"
            : d.balance_before_transfer + "$",
        balance_after_transfer:
          d.balance_after_transfer === undefined
            ? "Nan"
            : d.balance_after_transfer + "$",
        status:
          d.status === "success" ? (
            <div className="flex justify-center items-center">
              <DButton
                bgColor="success"
                className="  px-[25px_!important] text-white rounded-[50px_!important]"
              >
                {statusMessage(d.status)}
              </DButton>
            </div>
          ) : d.status === "failed" ? (
            <div className="flex justify-center items-center">
              <DButton
                bgColor="danger"
                className="  px-[25px_!important] text-white rounded-[50px_!important]"
              >
                {statusMessage(d.status)}
              </DButton>
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <DButton
                bgColor="secondry"
                className="  px-[25px_!important] text-white rounded-[50px_!important]"
              >
                {statusMessage(d.status)}
              </DButton>{" "}
            </div>
          ),
        created_at: moment(d.created_at).format("hh:mm:ss YYYY-MM-DD"),
        actions:
          d.status === "inprogress" ? (
            <div className="flex justify-center items-center">
              <DButton
                onClick={() => editRequestedBalance(d.id)}
                bgColor="primary"
                className="  text-white px-[25px_!important]  rounded-[50px_!important]"
              >
                تعديل
              </DButton>
            </div>
          ) : (
            ""
          ),
      }));
    }
    return [];
  };
  if (error) {
    return <Navigate to="/404" />;
  }
  return (
    <div>
      <PageHeading>{title}</PageHeading>
      <DCard className={`relative ${isLoading ? "min-h-[400px]" : ""}`}>
        {isLoading ? (
          <DSpinner />
        ) : (
          <Table
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalData={data.data.data.total}
            head={columns}
            body={formattedData(data.data.data.data)}
          />
        )}
      </DCard>
    </div>
  );
};

export default Index;
